<template>
    <div :class="[
        'border flex items-center bg-white py-12 px-12 shadow-sm trans-ease rounded',
        selected ? 'border-secondary' : 'border-transparent',
        jobHasSelected ? 'hover:border-secondary' : 'hover:border-primary-40',
    ]">
        <avatar
            :color="color"
            :image="application.image_url"
            size="small"
            class="mr-12"
            shape="round"
        >
            {{ application.initials }}
        </avatar>
        <div class="leading-none mr-auto">
            <div class="font-semibold mb-8">
                {{ application.fullName }}
            </div>
            <div class="flex items-center gap-8">
                <button :class="application.favorite ? 'hover:text-semantic-warning-dark text-semantic-warning' : 'hover:text-semantic-warning text-primary-60'"
                        :disabled="working"
                        role="button"
                        @click.stop="setFavorite"
                >
                    <svg-icon type="star" :filled="application.favorite"></svg-icon>
                </button>
                <div class="text-secondary flex items-center gap-4">
                    <score class="w-18 h-18" :score="application.score"></score>
                    <span :style="{ color: application.scoreColor }">
                        <span v-if="application.score !== null">
                            <span class="font-semibold">{{ application.score }}</span>
                            %
                        </span>
                        <span v-else>--</span>
                    </span>
                </div>
                <div class="text-primary-80 flex items-center gap-4 font-semibold">
                    <svg-icon type="schedule" />
                    <span>{{ application.createdMoment.locale(locale).fromNow(true) }}</span>
                </div>

                <div v-if="application.referrer_source === 'interim'" class="text-primary-80">
                    <svg-icon type="location-city"></svg-icon>
                </div>
            </div>
        </div>
        <progress-icon v-if="application.rejected" :stage="stage" class="mr-32" rejected></progress-icon>
    </div>
</template>

<script>
import Application from '../models/Application';
import Avatar from './ui/Avatar.vue';
import SvgIcon from './ui/SvgIcon.vue';
import Score from './ui/Score.vue';
import ProgressIcon from './ui/ProgressIcon.vue';
import Stage from '../models/Stage';
import * as users from '../services/UserService';
import {mapActions} from 'pinia';
import {useAuthenticationStore} from '../state/modules/authentication';

export default {
    components: {
        'avatar': Avatar,
        'svg-icon': SvgIcon,
        'score': Score,
        'progress-icon': ProgressIcon,
    },
    data() {
        return {
            working: false,
        };
    },
    props: {
        application: Application,
        stage: Stage,
        color: String,
        selected: Boolean,
        jobHasSelected: Boolean,
        locale: String,
    },
    methods: {
        ...mapActions(useAuthenticationStore, { applicationsSetFavorite: 'setFavorite' }),
        setFavorite() {
            this.working = true;
            this.applicationsSetFavorite({
                applicationId: this.application.id,
                favorite: this.application.favorite
            });
            this.working = false;
        },
    },
};
</script>
